import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { GeneralService } from '../../services/general.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [CommonModule, MatIcon, MatButtonModule, MatMenuModule, TranslateModule],
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() titleDetail: any;
  @Output() public sidenavToggle = new EventEmitter();

  lagnImage: string;
  name: string | null = '';
  updateEveryMS = 10000;
  subscription!: Subscription;
  counter: number = 0;
  appName: string = '';

  showTitleHeader: boolean;
  currentUrl: string | null = '';
  urlsWithoutHeader: string[] = ['/home', '/workflow'];

  public currentSection: string = '';

  constructor(
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private generalService: GeneralService,
  ) {
    this.lagnImage = 'assets/images/icon-cambiar-espaniol.svg';
    this.showTitleHeader = false;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.toLowerCase();

        if (url.includes('active-portfolio')) {
          this.currentSection = 'CARTERA ACTIVA';
        } else if (url.includes('workflow')) {
          this.currentSection = 'WORKFLOW';
        } else if (url.includes('quotation')) {
          this.currentSection = 'COTIZADOR';
        } else {
          this.currentSection = '';
        }
      }
    });
  }

  ngOnInit() {
    this.appName = environment.appName;
    this.currentUrl = this.router.url;
    if (this.urlsWithoutHeader.find((x) => x == this.currentUrl) == null) {
      this.showTitleHeader = true;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.name = localStorage.getItem('firstName');
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  };

  changeLang() {
    const currentLang = this.translate.defaultLang;
    if (currentLang === 'es') {
      localStorage.setItem('lang', 'en');
      this.translate.setDefaultLang('en');
      this.lagnImage = 'assets/images/icon-cambiar-ingles.svg';
    } else {
      localStorage.setItem('lang', 'es');
      this.translate.setDefaultLang('es');
      this.lagnImage = 'assets/images/icon-cambiar-espaniol.svg';
    }
  }

  logout() {
    this.authService.logout();
  }

  InboxNotifications() {
    this.router.navigate(['/notification/inbox']);
  }

  getClassByMenu(menu: any) {
    if (menu.route == this.router.url) {
      return 'mat-button active-menu';
    }
    return 'mat-button';
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  public goToUrl(route: string[], queryParams: { [key: string]: string | number }) {
    this.generalService.goToUrl(route, queryParams);
  }
}
